export default {"src":"/_next/static/media/MedicineLight.dd78af50.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};